import { Controller } from "stimulus"
import Tribute from "tributejs"
import Trix from "trix"

export default class extends Controller {
  static targets = ["field"]

  connect() {
    this.editor = this.fieldTarget.editor;
    window.editor = this.editor;
    this.initializeTribute();
  }

  disconnect() {
    this.tribute.detach(this.fieldTarget)
  }

  initializeTribute() {
    this.tribute = new Tribute({
      allowSpaces: true,
      lookup: 'name',
      values: this.fetchUsers,
    })
    this.tribute.attach(this.fieldTarget)
    this.tribute.range.pasteHtml = this._pasteHtml.bind(this)
    this.fieldTarget.addEventListener("tribute-replaced", this.replaced)
  }

  fetchUsers = (text, callback) => {
    let isCustomerChat = true;
    let isChannelMessage = false;
    let orderId = null;

    if (!this.editor) {
      this.editor = this.fieldTarget.editor
    }

    if (this.editor && this.editor.element) {
      isCustomerChat = this.editor.element.id !== 'send-box-2';

      if (this.editor.element.dataset.variable) {
        orderId = this.editor.element.dataset.orderId;
        isChannelMessage = this.editor.element.dataset.isChannel
      }
    } 

    if (orderId == null) {
      isCustomerChat = event.currentTarget.dataset.customerChat;
      isChannelMessage = false;
      orderId = event.currentTarget.dataset.orderId;
    }

  
    fetch(`/mentions.json?order_id=${orderId}&is_customer_chat=${isCustomerChat}&is_channel=${isChannelMessage}`)
      .then(response => response.json())
      .then(users => callback(users))
      .catch(() => callback([]))
  }

  replaced(e) {
    let mention = e.detail.item.original
    let attachment = new Trix.Attachment({
      sgid: mention.sgid,
      content: mention.content
    })
    this.editor.insertAttachment(attachment)
    this.editor.insertString(" ")
  }

  _pasteHtml(html, startPos, endPos) {
    if (!this.editor) {
      this.editor = this.fieldTarget.editor
    }

    let position = this.editor.getPosition()
    let tributeLength = endPos - startPos
    let trixStartPos = position - tributeLength
    let trixEndPos = position
    this.editor.setSelectedRange([trixStartPos, trixEndPos])
    this.editor.deleteInDirection("backward")
  }
}
